import { MealEntity } from "../MealsAndDrinks/MealEntity"
import { EProductOrderModeType } from "../../Enum/EProductOrderModeType"
import { GenericOrderFood } from "./GenericOrderFood"

export class OrderMeal extends GenericOrderFood {
  mealEntityId: number

  mealEntity: MealEntity

  constructor(data: Partial<OrderMeal> = {}) {
    super(data)

    this.mealEntityId = data.mealEntityId ?? -1

    this.mealEntity = new MealEntity(data.mealEntity)
  }

  protected override getJsonFields(): string[] {
    return [...super.getJsonFields(), "mealEntityId"]
  }

  needKitchen(): boolean {
    return this.mealEntity.genericFoodEntity.needKitchen
  }

  getName() {
    return this.mealEntity.genericFoodEntity.name
  }

  getImage() {
    return this.mealEntity.genericFoodEntity.iconUrl.toClientRequest()
  }

  getProductOrderMode(): EProductOrderModeType {
    return this.mealEntity.genericFoodEntity.productOrderMode
  }
}
